// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2ykLJ","itemTitle":"ClientEmergencyInfo_itemTitle__1qbrS","itemText":"ClientEmergencyInfo_itemText__3_z3T"};